import { PressableNeolexon } from '@/components/PressableNeolexon';
import { useResponsiveFontSize } from '@/components/Util/reactResponsiveDimensions';
import colors from '@/config/colors';
import { Feather } from '@expo/vector-icons';
import { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { AudioPlayer } from '../AudioPlayer';

const styles = StyleSheet.create({
  choiceContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circle: {
    backgroundColor: colors.grey,
    borderRadius: 50,
    borderWidth: 2,
    borderColor: colors.darkGrey,
  },
  feedbackCircle: {
    borderWidth: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleCorrect: {
    backgroundColor: colors.primary,
  },
  circleWrong: {
    backgroundColor: colors.red,
  },
  disabledStyle: {
    opacity: 0.5,
  },
});

export function Choice({
  choice,
  isDisabled,
  disableAll,
  activeAudioSrc,
  changeActiveAudioSrc,
  onPressChoice,
  playbackRate = 1.0,
}) {
  const { isCorrect, choiceAudio, isPressed } = choice;
  const feedBackIconSize = useResponsiveFontSize(1.5);
  const feedBackStyle = isCorrect ? styles.circleCorrect : styles.circleWrong;
  const feedBackIconName = isCorrect ? 'thumbs-up' : 'thumbs-down';

  const onPress = useCallback(() => {
    onPressChoice(choiceAudio);
    if (isCorrect) disableAll();
  }, []);

  const circleSize = Math.min(useResponsiveFontSize(3), 64);
  const audioSize = Math.min(useResponsiveFontSize(6), 96);

  const responsiveStyles = StyleSheet.create({
    circle: {
      height: circleSize,
      width: circleSize,
    },
    audioPlayer: {
      height: audioSize,
      width: audioSize,
    },
  });

  return (
    <View style={styles.choiceContainer}>
      {isPressed ? (
        <View
          style={[
            styles.circle,
            responsiveStyles.circle,
            styles.feedbackCircle,
            feedBackStyle,
          ]}
        >
          <Feather
            name={feedBackIconName}
            size={feedBackIconSize}
            color={colors.white}
          />
        </View>
      ) : (
        <PressableNeolexon
          disabled={isDisabled}
          onPress={onPress}
          style={[
            styles.circle,
            responsiveStyles.circle,
            isDisabled && styles.disabledStyle,
          ]}
        >
          <View />
        </PressableNeolexon>
      )}
      <Text> </Text>
      <View style={responsiveStyles.audioPlayer}>
        <AudioPlayer
          isDisabled={isDisabled || isPressed}
          isMiniPlayer
          source={choiceAudio}
          playbackRate={playbackRate}
        />
      </View>
    </View>
  );
}
